import { lazy } from 'react';

export default lazy(
  () =>
    import(
      /* webpackChunkName: "all-vendor-uploads" */
      './AllVendorUploads'
    )
);
